// extracted by mini-css-extract-plugin
export var avatarContainer = "_6n-0";
export var avatarTypingWave = "_6n-i";
export var gray = "_6n-f";
export var green = "_6n-c";
export var icon = "_6n-9";
export var image = "_6n-1";
export var lg = "_6n-6";
export var md = "_6n-5";
export var presenceDot = "_6n-b";
export var red = "_6n-d";
export var sm = "_6n-4";
export var status = "_6n-a";
export var typingDot = "_6n-h";
export var typingPill = "_6n-g";
export var xl = "_6n-7";
export var xs = "_6n-3";
export var xxl = "_6n-8";
export var xxs = "_6n-2";
export var yellow = "_6n-e";